module.exports = __webpack_public_path__ + "img/h_s1e2_gallery_4.f8135f0a.png";